import { skipToken } from "@reduxjs/toolkit/query";
import {
  type FrameOptions,
  type ContentOptions,
  createEmbeddingContext,
} from "amazon-quicksight-embedding-sdk";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import {
  useQuicksightEmbedUrlQuery,
  useQuicksightReportQuery,
} from "api/memberPortal/reports/quicksight/quicksight.api";
import { usePageTitle } from "hooks/usePageTitle";

const QuicksightReport = () => {
  const { id } = useParams();
  const dashboardRef = useRef<HTMLDivElement | null>(null);
  const { data: embedUrl } = useQuicksightEmbedUrlQuery(id || skipToken);
  const { data: dashboard } = useQuicksightReportQuery(id ?? skipToken);

  usePageTitle(dashboard?.name || "Quicksight Report");

  // Initialize Context
  useEffect(() => {
    const embedDashboardOnPage = async () => {
      if (!embedUrl || !dashboardRef.current) return;

      const embeddingContext = await createEmbeddingContext();
      const { embedDashboard } = embeddingContext;

      const frameOptions: FrameOptions = {
        url: embedUrl,
        container: dashboardRef.current,
        withIframePlaceholder: true,
      };
      const contentOptions: ContentOptions = {};

      await embedDashboard(frameOptions, contentOptions);
    };

    embedDashboardOnPage();
  }, [embedUrl, dashboardRef]);

  return (
    <div
      ref={dashboardRef}
      style={{ height: "calc(100% - 6em)", maxHeight: "100%", margin: "1em" }}
    />
  );
};
export default QuicksightReport;
